import { useMemo, useState } from "react";

import { Button } from "V2.0/common/button";
import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import { DialogTitleWithClose } from "V2.0/components/DialogTitleWithClose";
import { TTSSettings } from "./TTSSettings";
import { PencilIcon } from "@heroicons/react/24/outline";
import { ChevronDownIcon, Cog6ToothIcon } from "@heroicons/react/20/solid";
import { TTSProviderSettings } from "./TTSProviderSettings/TTSProviderSettings";
import { MicrophoneIcon } from "@heroicons/react/24/solid";

const newVoices = {
  Eva: { label: "Eva (multilingual)" },
  Andy: { label: "Andy (multilingual)" },
  Ian: { label: "Ian (English-AU)" },
  Carly: { label: "Carly (English-US)" },
  Sophia: { label: "Sophia (English-US)" },
  Ignacio: { label: "Ignacio (English-US)" },
  // Cindy: { label: "Cindy (English-US)" },
  // Arthor: { label: "Arthor (English-US)" },
  Kavya: { label: "Kavya (Hindi)" },
  Shantanu: { label: "Shantanu (Hindi)" },
  Lucia: { label: "Lucia (Spanish)" },
  Fernanda: { label: "Fernanda (Spanish)" },
  Asif: { label: "Asif (Urdu)" },
  Sabbah: { label: "Sabbah (Arabic-UAE)" },
  Aisha: { label: "Aisha (Arabic)" },
  Ismail: { label: "Ismail (Arabic)" },
  Agata: { label: "Agata (Polish)" },
  Piyali: { label: "Piyali (Bengali)" },
  Eliana: { label: "Eliana (Hebrew)" },
  Moshe: { label: "Moshe (Hebrew)" },
  Inbar: { label: "Inbar (Hebrew)" },
  Saad: { label: "Saad (Indian English)" },
  Nisha: { label: "Nisha (Indian English)" },
  Shilpa: { label: "Shilpa (Indian English)" },
  Divya: { label: "Divya (Hinglish)" },
  Dhruv: { label: "Dhruv (Hindi)" },
};

// const voices = {
//   Eva: { label: "Eva (Multilingual)" },
//   Andy: { label: "Andy (Multilingual)" },
//   Cindy: { label: "Cindy (English-US)" },
//   Arthor: { label: "Arthor (English US, Male)" },
//   Antoine: { label: "Antoine (Female, French)" },
//   Liz: { label: "Liz (Female, English US)" },
//   Brendan: { label: "Brendan (Male, English US)" },
//   Sonia: { label: "Sonia (Female, English UK)" },
//   Max: { label: "Max (Male, German)" },
//   Felix: { label: "Felix (Male, German)" },
//   Aurora: { label: "Aurora (Female, Italian)" },
//   Marco: { label: "Marco (Male, Italian)" },
//   Giovanni: { label: "Giovanni (Male, Italian)" },
//   Martina: { label: "Martina (Female, Italian)" },
//   Leonardo: { label: "Leonardo (Male, Italian)" },
//   Sofia: { label: "Sofia (Female, Italian)" },
//   Nat: { label: "Nat (Male, English AU)" },
//   Ann: { label: "Ann (Female, English AU)" },
//   Jo: { label: "Jo (Female, English AU)" },
//   Will: { label: "Will (Male, English AU)" },
//   Elise: { label: "Elise (Female, English AU)" },
//   Dunn: { label: "Dunn (Male, English AU)" },
//   Sharma: { label: "Sharma (Male, Hindi)" },
//   Shantanu: { label: "Shantanu (Male, Hindi)" },
//   Vikram: { label: "Vikram (Male, Hindi - Devanagri Script Only)" },
//   Kavya: { label: "Kavya (Female, Hindi)" },
//   Sindhu: { label: "Sindhu (Female, Hindi)" },
//   Neha: { label: "Neha (Female, Hindi)" },
//   Afonso: { label: "Afonso (Male, Portuguese)" },
//   Artur: { label: "Artur (Male, Brazilian Portuguese)" },
//   Evora: { label: "Evora (Female, Brazilian Portuguese)" },
//   Cassandra: { label: "Cassandra (Female, Brazilian Portuguese)" },
//   Lisa: { label: "Lisa (Female, English US)" },
//   Cart: { label: "Cart (Male, English US)" },
//   Kyle: { label: "Kyle (Male, English US)" },
//   Charlotte: { label: "Charlotte (Female, French)" },
//   Alain: { label: "Alain (Male, French)" },
//   Juliette: { label: "Juliette (Female, French)" },
//   Louis: { label: "Louis (Male, French)" },
//   Charles: { label: "Charles (Male, French)" },
//   Lucia: { label: "Lucia (Female, Spanish)" },
//   Diego: { label: "Diego (Male, Spanish)" },
//   Maria: { label: "Maria (Female, Spanish)" },
//   Jose: { label: "Jose (Male, Spanish)" },
//   Juan: { label: "Juan (Male, Spanish)" },
//   Felipe: { label: "Felipe (Male, Spanish)" },
//   Fernanda: { label: "Fernanda (Female, Spanish)" },
//   Juan: { label: "Juan (Male, Argentinian Spanish)" },
//   Ines: { label: "Ines (Female, Argentinian Spanish)" },
//   Sophia: { label: "Sophia (Female, English US)" },
//   Ignacio: { label: "Ignacio (Male, English US)" },
//   Britt: { label: "Britt (Female, English)" },
//   Marcus: { label: "Marcus (Male, English)" },
//   Cynthia: { label: "Cynthia (Female, English)" },
//   Cath: { label: "Cath (Female, English)" },
//   Nick: { label: "Nick (Male, English)" },
//   Jean: { label: "Jean (Male, French)" },
//   Madeleine: { label: "Madeleine (Female, French)" },
//   Joelle: { label: "Joelle (Female, French)" },
//   Camille: { label: "Camille (Female, French)" },
//   Celine: { label: "Celine (Female, French)" },
//   Jacques: { label: "Jacques (Female, French)" },
//   Jan: { label: "Jan Schevenels (Male, Flemish)" },
//   Petra: { label: "Petra (Female, Flemish)" },
//   HansC: { label: "Hans (Male, Flemish)" },
//   Ben: { label: "Ben van Praag (Male, Flemish)" },
//   Christian: { label: "Christian - Nieuws Stijl (Male, Flemish)" },
//   Walter: { label: "Walter (Male, Flemish)" },
//   Bart: { label: "Bart(Male, Flemish)" },
//   Adrien: { label: "Adrien (Male, French(Belgie))" },
//   Christophe: { label: "Christophe (Male, French(Belgie))" },
// };

function TTS(props) {
  const { settings, syncAssistant, assistantId, workspaceId, voices, locked } = props;
  const [open, setOpen] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);

  const inputField = useMemo(() => {
    if (settings?.voiceId) {
      if (settings?.voiceId === "Cindy" || settings?.voiceId === "Arthor") {
        return { voiceId: "Eva" };
      }

      return { voiceId: settings?.voiceId };
    }
    return { voiceId: "" };
  }, [settings]);

  const voicesList = useMemo(() => {
    const newVoicesList = voices.reduce((acc, voice) => {
      const { voiceSettings } = voice;
      const { voiceName } = voiceSettings;
      return {
        ...acc,
        [voiceName]: { label: voiceName },
      };
    }, {});

    const updatedVoicesList = {
      ...newVoices,
      ...newVoicesList,
    };
    return updatedVoicesList;
  }, [voices]);

  const voicesOptions = useMemo(() => {
    const voicesListKeys = Object.keys(voicesList);
    const voicesListOptions = voicesListKeys.map((voice, idx) => {
      return { id: idx, value: voice, label: voicesList[voice].label };
    });

    return voicesListOptions;
  }, [voicesList]);

  const voice = voicesList[inputField.voiceId]?.label;

  const ttsServiceProvider = settings?.ttsServiceProvider;
  const showTTSSettings =
    ttsServiceProvider === "elevenlabs" ||
    ttsServiceProvider === "azuretts" ||
    ttsServiceProvider === "googletts" ||
    // ttsServiceProvider === "rimeai" ||
    ttsServiceProvider === "cartesia";

  return (
    <div className="flex items-center border rounded-lg">
      <div className="flex items-center px-2 gap-x-2">
        <MicrophoneIcon className="size-4" />
        <p className="text-sm">{voice}</p>
      </div>
      {!locked && <div className="border-r">
        <Button
          plain
          onClick={() => setOpen(true)}
        >
          <ChevronDownIcon />
        </Button>
      </div>}
      {showTTSSettings && !locked && (
        <Button
          plain
          onClick={() => setOpenSettings(true)}
        >
          <Cog6ToothIcon />
        </Button>
      )}
      {open && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
        >
          <DialogTitle>
            <DialogTitleWithClose
              title={"Select Voice"}
              onClose={() => setOpen(false)}
            />
          </DialogTitle>
          <DialogBody>
            <TTSSettings
              voicesOptions={voicesOptions}
              settings={inputField}
              syncAssistant={syncAssistant}
              assistantId={assistantId}
              workspaceId={workspaceId}
              onSuccess={() => setOpen(false)}
            />
          </DialogBody>
        </Dialog>
      )}
      {openSettings && (
        <Dialog
          open={openSettings}
          onClose={() => setOpenSettings(false)}
        >
          <DialogTitle>Voice Settings</DialogTitle>
          <DialogBody>
            {TTSProviderSettings[ttsServiceProvider]({
              ...settings,
              syncAssistant,
              assistantId,
              workspaceId,
              onClose: () => setOpenSettings(false),
            })}
          </DialogBody>
        </Dialog>
      )}
    </div>
  );
}

export { TTS };
